<template>
  <v-dialog
    v-model="show"
    width="328px">
    <div class="dialog-container">
      <h2 v-if="title">{{ title }}</h2>
      <p>
        {{ message }}
      </p>
      <b>{{ tips }}</b>
      <div class="dialog-footer">
        <!-- <div> -->
        <v-button
          :type="btnType"
          @click="onConfirm">{{ confirmBtn }}</v-button>
        <!-- </div> -->
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmBox',
  data() {
    return {
      show: false,
      title: '',
      message: '',
      cancelBtn: 'Cancel',
      btnType: 'primary',
      confirmBtn: 'OK',
      tips: ''
    }
  },
  methods: {
    // confirm() {
    //   return new Promise((resolve, reject) => {
    //     this.promiseStatus = {
    //       resolve,
    //       reject
    //     }
    //   })
    // },
    // onCancel() {
    //   this.show = false
    // },
    onConfirm() {
      this.show = false
      if(this.tips){
        this.$emit('clearOptions')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 30px 20px 20px;
      color: #616266;
      h2 {
          font-size: 24px;
          line-height: 30px;
      }
      p {
        padding-bottom: 10px;
        font-size: 16px;
        line-height: 18px;
      }
      .dialog-footer {
          margin-top: 15px;
          text-align: right;
      }
    }
</style>